import React, { useState } from 'react';
import { ItemScheme } from '../../../../../Components/Form/MagicFormItem';
import { MagicField } from '../../../../../Enums/MagicField.enum';
import MagicForm from '../../../../../Components/Form/MagicForm';
import { CreateGroupFormValues } from '../../../Interfaces/CreateGroupFormValues.interface';
import {
	CreateGroupInput,
	useCreateGroupMutation,
} from '../../../../../graphql/graphql';
import { useSelectUsersContext } from '../../../Services/SelectUsersContext';
import { useGroupsContext } from '../../../Services/GroupsContext';
import { CreateGroupMode } from '../../../Enums/CreateGroupMode.enum';
import useApiClient from '../../../../Base/Hooks/useApiClient';
import useNotification from '../../../../../Hooks/useNotification.hook';
import { GroupListContent } from '../../../Enums/GroupListContent.enum';

interface Props {
	onSubmit: () => void;
}

const formScheme: ItemScheme[] = [
	{
		type: MagicField.TEXT_FIELD,
		key: 'name',
		title: 'base.groupName',
		defaultValue: '',
		settings: {
			required: true,
		},
	},
];

const EArchiveGroupsListCreateModalForm = (props: Props) => {
	const [isLoading, setIsLoading] = useState(false);
	const [createGroup] = useCreateGroupMutation();
	const { userIds, stopSelectingUsers } = useSelectUsersContext();
	const { createGroupMode, setCreateGroupMode, setGroupListContent } =
		useGroupsContext();
	const { displayGQLError } = useApiClient();
	const { showNotificationSuccess } = useNotification();

	const onSubmit = async ({ name }: CreateGroupFormValues) => {
		setIsLoading(true);

		const input: CreateGroupInput = { name };
		switch (createGroupMode) {
			case CreateGroupMode.SELECTED_USERS:
				input.userIds = userIds;
				break;
			case CreateGroupMode.ALL_USERS:
				input.shouldAddAllUsers = true;
				break;
			default:
				break;
		}

		const response = await createGroup({ input });
		displayGQLError(response);
		if ('data' in response) {
			showNotificationSuccess({
				content: 'component.eArchive.groups.createGroupSuccess',
			});
			setCreateGroupMode(undefined);
			setGroupListContent(GroupListContent.GROUPS);
			stopSelectingUsers();
			props.onSubmit();
		}

		setIsLoading(false);
	};

	return (
		<MagicForm
			formScheme={formScheme}
			onSubmit={onSubmit}
			submitText={'base.shared.form.send'}
			disableSubmit={isLoading}
		/>
	);
};

export default EArchiveGroupsListCreateModalForm;
